<template >
  <div class="container" v-if="school">
    <!-- DataTales Example -->
    <div class="card my-4">
      <div class="card-header py-3">
        <div class="row">
          <div class="col col-expand">
            <h6 class="m-0 font-weight-bold text-primary">
              Ангиуд - {{ school.currentYear - 1 }}
            </h6>
          </div>
          <div class="col col-auto">
            <div class="col-auto">
              <!-- <div @click="$router.push({ 'name':'ILessonAdd' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm mr-2">Хичээл нэмэх</div> -->
              <!-- <div @click="$router.push({ 'name':'ILessonAddGroup' , params:{ schoolId: schoolId, setTeacher: true }})" class="btn btn-danger btn-sm">Хичээл багцалж нэмэх</div> -->
            </div>
          </div>
        </div>
      </div>
      <div
        class="card-body"
        v-if="departments != null && departments.length > 0"
      >
        <div class="table-responsive">
          <table
            class="table table-bordered"
            id="dataTable"
            width="100%"
            cellspacing="0"
          >
            <thead>
              <tr>
                <th width="1%">№</th>
                <th>Нэр</th>
                <th>Сурагчдын тоо</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(dep, index) in departments" v-bind:key="dep.id">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ dep.name }} анги / (
                  <span
                    class="text-danger"
                    v-if="dep.programs != undefined && dep.programs != null"
                    >{{ dep.programs.length }}</span
                  >
                  )
                </td>
                <td>{{ dep.numberOfStudents }}</td>
                <td v-if="dep.programs != undefined && dep.programs != null">
                  <span v-for="(prog, i) in dep.programs" :key="i">
                    <span v-if="prog.upgraded" class="btn btn-success mr-2">{{
                      prog.name.toUpperCase()
                    }} <span>({{prog.numberOfStudents}})</span></span>
                    <span
                      v-else
                      class="btn btn-danger mr-2"
                      @click="_moveDialog(dep, prog)"
                      >{{ prog.name.toUpperCase() }}</span
                    >
                  </span>
                </td>
                <!-- <td>{{topic.createdAt | formatDate}}</td> -->

                <td>
                  <!-- <button class="btn btn-success btn-sm mr-2" @click="goDetailLesson(dep)">хичээл</button> -->
                  <button class="btn btn-primary btn-sm" @click="goDetail(dep)">
                    xараx
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div v-else class="alert alert-warning">
        Одоогоор Ангиийн мэдээлэл ороогүй байна.
      </div>
    </div>

    <div
      class="modal fade"
      id="openMoveModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="depModalLabel"
      aria-hidden="true"
      data-keyboard="false"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="depModalLabel">xxx</h5>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <div class="col">
                  <p v-if="fromDepartment && fromProgram">
                    {{ fromDepartment.name }} {{ fromProgram.name }}
                  </p>
                </div>
              </div>
              <div class="form-group">
                <div class="col">
                  <div class="form-group">
                    <label for="exampleFormControlSelect1">xxxx xssd</label>
                    <select class="form-control" v-model="xdepartment">
                      <option
                        v-for="(xdepartment, sindex) in departments2021"
                        v-bind:value="xdepartment"
                        :key="sindex"
                      >
                        <span
                          >{{ xdepartment.name }} --
                          {{ xdepartment.startYear }}</span
                        >
                      </option>
                    </select>
                  </div>
                  <div class="form-group" v-if="xdepartment">
                    <label for="exampleFormControlSelect1"
                      >Бүлгээ сонгоно уу</label
                    >
                    <select class="form-control" v-model="xprogram">
                      <option
                        v-for="(progr, sindex) in xdepartment.programs"
                        v-bind:value="progr"
                        :key="sindex"
                      >
                        <span>{{ progr.name.toUpperCase() }} </span>
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              type="button"
              class="btn btn-primary btn-user btn-block"
              @click="_moveProgram(xdepartment, xprogram)"
            >
              Шилжүүлэx
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      school: null,
      department: {
        name: null,
        shortName: null,
        description: null,
        startYear: 2020,
      },

      xdepartment: null,
      departments: [],
      departments2021: [],

      xprogram: null,

      fromDepartment: null,
      fromProgram: null,
    };
  },
  methods: {
    _moveDialog(dep, prog) {
      this.fromDepartment = dep;
      this.fromProgram = prog;
      this.xdepartment = null;
      this.xprogram = null;
      $("#openMoveModal").modal();
    },
    async _moveProgram(xdepartment, xprogram) {
      console.log(xdepartment.ref.path, xprogram.ref.path);
      console.log(
        xdepartment.name + "-" + xdepartment.startYear,
        xprogram.name
      );
      if (this.school) {
        var studentsRef = await this.school.ref
          .collection("/students")
          .where("program", "==", this.fromProgram.ref)
          .get();

        if (!studentsRef.empty) {
 
          studentsRef.docs.forEach((doc) => {
            let student = doc.data();
            student.id = doc.id;
            student.ref = doc.ref;
            student.ref.update({                                                                          
              "department-2021": xdepartment.ref,
              "program-2021": xprogram.ref,
            });
          });
          this.fromProgram.ref
            .update({ upgraded: true, numberOfStudents: studentsRef.size }).then(() => {
              this.xprogram.ref.update({numberOfStudents: studentsRef.size})
              $("#openMoveModal").modal("hide");
              alert("Successfully moved: " + studentsRef.size + " students")
            });
        }
      }
      console.log(studentsRef);
    },
    async _initData() {
      var schoolRef = await fb.db
        .collection("schools")
        .doc(this.schoolId)
        .get();

      if (schoolRef.exists) {
        console.log(schoolRef.id);
        let school = schoolRef.data();
        school.id = schoolRef.id;
        school.ref = schoolRef.ref;
        this.school = school;
      }
      this._getDepartments(this.school.currentYear - 1, this.departments);
      this._getDepartments(this.school.currentYear);
    },
    _getDepartments(startYear, departments) {
      if (this.school != null) {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .collection("departments")
          .where("startYear", "==", startYear)
          .orderBy("createdAt", "desc")
          .onSnapshot((querySnapshot) => {
            this.departments = [];
            this.departments2021 = [];
            querySnapshot.forEach((doc) => {
              let dep = doc.data();
              dep.id = doc.id;
              dep.ref = doc.ref;
              dep.ref
                .collection("programs")
                .orderBy("name", "asc")
                .onSnapshot((querySnapshot) => {
                  dep.programs = [];
                  querySnapshot.forEach((doc) => {
                    // doc.data() is never undefined for query doc snapshots
                    console.log(doc.id, " => ", doc.data());
                    let prog = doc.data();
                    prog.id = doc.id;
                    prog.ref = doc.ref;
                    dep.programs.push(prog);
                  });
                  if (startYear == 2020) this.departments.push(dep);
                  else if (startYear == 2021) this.departments2021.push(dep);
                });

              // fb.db.collection("schools/"+this.schoolId+"/students").where("department", "==", doc.ref).get().then(stdocs=>{
              //   if(stdocs && !stdocs.empty){
              //     doc.ref.update({numberOfStudents: stdocs.size});
              //   }
              // });
            });
          });
      }
    },

    goDetail(dep) {
      this.$router.push({
        name: "DepartmentDetail",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
    goDetailLesson(dep) {
      this.$router.push({
        name: "SCategories",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  created() {
    var _this = this;
    if (this.schoolId != null && this.schoolId != "") this._initData();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

